import { render, staticRenderFns } from "./PatientTable.vue?vue&type=template&id=dc6161c4&scoped=true&"
import script from "./PatientTable.vue?vue&type=script&lang=js&"
export * from "./PatientTable.vue?vue&type=script&lang=js&"
import style0 from "./PatientTable.vue?vue&type=style&index=0&id=dc6161c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6161c4",
  null
  
)

export default component.exports